/**
 * common
 *
 * @description mappings
 * @author Shigq
 * @date 2021/4/19 15:56
 */
import { reactive } from 'vue'
import store from '@/store'

export default function() {
  /* todo - static store */
  const scopedStaticStore = reactive({
    dict: store.state.base.dict,
    constant: store.state.base.constant,
    country: store.state.base.country,
  })

  return {
    ...scopedStaticStore,
  }
}
